import { readApiErrorResponse } from "@/lib/api-error";
import { apiFetch } from "@/services/http/api-fetch";

/** H4: the current Terms of use version and whether this member still has to accept it. */
export type TermsStatus = { version: string; termsRequired: boolean };

export async function fetchTermsStatus(): Promise<TermsStatus> {
  const res = await apiFetch("/v1/terms");
  if (!res.ok) throw await readApiErrorResponse(res);
  return ((await res.json()) as { data: TermsStatus }).data;
}

export async function acceptTerms(): Promise<TermsStatus & { acceptedAt: string }> {
  const res = await apiFetch("/v1/terms/accept", { method: "POST" });
  if (!res.ok) throw await readApiErrorResponse(res);
  return ((await res.json()) as { data: TermsStatus & { acceptedAt: string } }).data;
}
